import React from "react";
import axios from "axios";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from "@mui/material";
import { GlobalState } from "context/GlobalContext";

const FileLogsDialog = ({ open, onClose, logId, details, loading }) => {
	// inside FileDetailsDialog.jsx
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const handleDownload = async (file_name) => {
		try {
			const res = await axios.post(`/api/shipping_partner_reco/get_file_logs/download`, {
				file_name,
			});

			const { downloadUrl } = res.data;

			// Redirect browser to signed URL
			window.location.href = downloadUrl;
		} catch (err) {
			console.error("Download error:", err);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: "Failed to download file", severity: "error" });
		}
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
			<DialogTitle>File Details for ID : {logId}</DialogTitle>
			<DialogContent>
				{loading ? (
					<CircularProgress />
				) : details.length > 0 ? (
					details.map((file) => (
						<div
							key={file.id}
							style={{
								display: "flex",
								justifyContent: "space-between",
								marginBottom: "10px",
							}}>
							<Typography>
								{file.file_name} ({file.file_type})
							</Typography>
							<Button
								variant="contained"
								color="primary"
								// href={file.file_gs_url}
								target="_blank"
								rel="noopener noreferrer"
								onClick={() => handleDownload(file.file_gs_url)}>
								Download
							</Button>
						</div>
					))
				) : (
					<Typography>No files found.</Typography>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

export default FileLogsDialog;
